import "./App.css";
import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Blogs from "./components/Blogs";
import About from "./components/About";
import Projects from "./components/Projects";
import Home from "./components/Home";
import "./components/CSS/card.css";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const DATA_ENDPOINT = process.env.REACT_APP_DATA_ENDPOINT || "";

const normalizeData = (incoming) => {
  if (!incoming || typeof incoming !== "object") {
    return { profile: [], project: [], blogs: [] };
  }

  return {
    profile: Array.isArray(incoming.profile) ? incoming.profile : [],
    project: Array.isArray(incoming.project)
      ? incoming.project
      : Array.isArray(incoming.projects)
        ? incoming.projects
        : [],
    blogs: Array.isArray(incoming.blogs) ? incoming.blogs : [],
  };
};

const withCacheBust = (url) => {
  if (!url) return url;
  const stamp = `t=${Date.now()}`;
  return url.includes("?") ? `${url}&${stamp}` : `${url}?${stamp}`;
};

function App() {
  const [data, setData] = useState({ profile: [], project: [], blogs: [] });

  useEffect(() => {
    if (!DATA_ENDPOINT) {
      return;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(withCacheBust(DATA_ENDPOINT), { cache: "no-store" });
        if (!response.ok) {
          return;
        }
        const json = await response.json();
        setData(normalizeData(json));
      } catch (err) {
        // silent fallback
      }
    };

    fetchData();
  }, []);

  return (
    <div className="app-shell">
      <Router>
        <Navbar />
        <Switch>
          <Route exact path={"/"}>
            <Home data={data} />
          </Route>
          <Route path={"/aboutme"}>
            <About data={data} />
          </Route>
          <Route path={"/blogs"}>
            <Blogs data={data} />
          </Route>
          <Route path={"/projects"}>
            <Projects data={data} />
          </Route>
          <Route path={"/resume"}>
            <Resume />
          </Route>
          <Route path={"/contact"}>
            <Contact data={data} />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
